export default __webpack_public_path__ + "static/media/equipment-supply.4541c8e9.png";